// extracted by mini-css-extract-plugin
export default {"button":"Button_button__sMVh4","addbutton":"Button_addbutton__by3TP","addbutton__text":"Button_addbutton__text__mFx+n"};